import React from "react";
import { scaleRotate as Menu } from "react-burger-menu";
import { push as Menu1 } from "react-burger-menu";
import { useMenu } from "../context/MenuContext";
import useTab from "../hooks/useTab";
import useMobile from "../hooks/useMobile";
// import { Link } from "react-router-dom";
import { useLoader } from "../context/LoaderContext";
import { scroller } from "react-scroll";

const SidebarMenu = () => {
  const { menuOpen, setMenuOpen, handleStateChange } = useMenu();
  const { setLoading } = useLoader();
  const tab = useTab();
  const mobile = useMobile();
  const linkClicker = (path: string) => {
    const pathLocation = window.location.pathname.includes(path);
    if (!pathLocation) {
      setLoading(true);
      window.scrollTo(0, 0);
      setMenuOpen(false);
    } else {
      setMenuOpen(false);
      scroller.scrollTo("toTop", {
        duration: 500,
        smooth: true,
      });
    }
  };
  return (
    <>
      {tab || mobile ? (
        <Menu1
          isOpen={menuOpen}
          onStateChange={handleStateChange}
          pageWrapId={"page-wrap"}
          outerContainerId={"outer-container"}
          customBurgerIcon={false}
          customCrossIcon={false}
          styles={{
            bmBurgerButton: {
              display: "none",
            },
            bmCrossButton: {
              height: "24px",
              width: "24px",
            },
            bmMenuWrap: {
              position: "fixed",
              height: "100%",
              width: "300px",
            },
            bmMenu: {
              overflow: "hidden",
              background: "white",
              padding: "115px 50px 50px 50px",
              fontSize: "0.15em",
            },
            bmItemList: {
              color: "#b8b7ad",
              padding: "0.8em",
            },
            bmItem: {
              display: "block",
              fontSize: "20px",
              fontWeight: "400",
              textDecoration: "none",
            },
            bmOverlay: {
              background: "unset",
            },
          }}
        >
          <a id="home" className="menu-item" href="/">
            Home
          </a>
          <a
            id="our-rooms"
            className="menu-item"
            href="/our-rooms"
            onClick={() => linkClicker("our-rooms")}
          >
            Our Rooms
          </a>
          <a
            id="aboutus"
            className="menu-item"
            href="/aboutus"
            onClick={() => linkClicker("aboutus")}
          >
            About Us
          </a>
          <a
            id="contact"
            className="menu-item"
            href="/contact"
            onClick={() => linkClicker("contact")}
          >
            Contact
          </a>
          {/* <Link
            id="about"
            className="menu-item disabled-link"
            to="/"
            onClick={(e) => e.preventDefault()}
          >
            Testimonials
          </Link> */}
          <a
            id="contact"
            className="menu-item"
            href="/gallery"
            onClick={() => linkClicker("gallery")}
          >
            Gallery
          </a>
          <a
            id="faqs"
            className="menu-item"
            href="/faqs"
            onClick={() => linkClicker("faqs")}
          >
            FAQs
          </a>
          <a
            id="termscondition"
            className="menu-item"
            href="/terms-and-condition"
            onClick={() => linkClicker("terms-and-condition")}
          >
            Terms and Conditions
          </a>
        </Menu1>
      ) : (
        <Menu
          isOpen={menuOpen}
          onStateChange={handleStateChange}
          pageWrapId={"page-wrap"}
          outerContainerId={"outer-container"}
          customBurgerIcon={false}
          customCrossIcon={false}
          styles={{
            bmBurgerButton: {
              display: "none",
            },
            bmCrossButton: {
              height: "24px",
              width: "24px",
            },
            bmMenuWrap: {
              position: "fixed",
              height: "100%",
              width: "400px",
            },
            bmMenu: {
              overflow: "hidden",
              background: "white",
              padding: "115px 90px 90px 90px",
              fontSize: "0.15em",
            },
            bmItemList: {
              color: "#b8b7ad",
              padding: "0.8em",
            },
            bmItem: {
              display: "block",
              fontSize: "20px",
              fontWeight: "400",
              textDecoration: "none",
            },
            bmOverlay: {
              background: "unset",
            },
          }}
        >
          <a id="home" className="menu-item" href="/">
            Home
          </a>
          <a
            id="our-rooms"
            className="menu-item"
            href="/our-rooms"
            onClick={() => linkClicker("our-rooms")}
          >
            Our Rooms
          </a>
          <a
            id="aboutus"
            className="menu-item"
            href="/aboutus"
            onClick={() => linkClicker("aboutus")}
          >
            About Us
          </a>
          <a
            id="contact"
            className="menu-item"
            href="/contact"
            onClick={() => linkClicker("contact")}
          >
            Contact
          </a>
          {/* <Link
            id="about"
            className="menu-item disabled-link"
            to="/"
            onClick={(e) => e.preventDefault()}
          >
            Testimonials
          </Link> */}
          <a
            id="contact"
            className="menu-item"
            href="/gallery"
            onClick={() => linkClicker("gallery")}
          >
            Gallery
          </a>
          <a
            id="faqs"
            className="menu-item"
            href="/faqs"
            onClick={() => linkClicker("faqs")}
          >
            FAQs
          </a>
          <a
            id="termscondition"
            className="menu-item"
            href="/terms-and-condition"
            onClick={() => linkClicker("terms-and-condition")}
          >
            Terms and Conditions
          </a>
        </Menu>
      )}
    </>
  );
};

export default SidebarMenu;
